import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Design = () => {
    return (
        <div className="teboil-design">
            <FullWrapper>
                <div className="teboil-designWrapper">
                    <div className="teboil-designTitle">Дизайн</div>
                    <div className="teboil-designTextWrapper">
                        <div className="teboil-designText">
                            Важное условие проекта&nbsp;&mdash; синхронизация с&nbsp;основным сайтом
                            по&nbsp;дизайну и&nbsp;стилистике, чтобы показать преемственность бренда
                            <a
                                href="https://teboil.ru/"
                                target="_blank"
                                className="teboil-designLink"
                                rel="noopener noreferrer nofollow"
                            >
                                https://teboil.ru/
                            </a>
                        </div>
                        <div className="teboil-designText">
                            От&nbsp;клиента команда получила брендбук. В&nbsp;формировании структуры
                            опирались на&nbsp;основной сайт и&nbsp;на&nbsp;схожие решения для
                            проектов других брендов. Помимо визуально-цветовой концепции было важно
                            согласовать тексты, расположение элементов, акценты и&nbsp;механику
                            взаимодействия сайта с&nbsp;посетителем.
                        </div>
                    </div>
                    <div className="teboil-designList">
                        <div className="teboil-designName">shop.teboil</div>
                        <img
                            src="/images/pic/teboil/shopteboil.jpg"
                            alt="shopteboil"
                            className="teboil-designImage"
                        />
                    </div>
                    <div className="teboil-designList">
                        <div className="teboil-designName">teboil.ru</div>
                        <img
                            src="/images/pic/teboil/teboilru.jpg"
                            alt="teboilru"
                            className="teboil-designImage"
                        />
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Design;
